import React from 'react'

/**
 * Convenience wrapper over React's useMemo when used to fall back to default values.
 * Returns the provided value, or the provided default value if the value was undefined/null.
 * @param value The value to return if defined.
 * @param defaultValue The default value to return if 'value' is undefined or null; only evaluated once per hook declaration.
 * @returns The value if it was defined, or defaultValue otherwise.
 */
export function useDefaultValue<T>(value: T, defaultValue: T): T {
  // note that defaultValue is intentionally not included in the dependencies here
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useMemo(() => value ?? defaultValue, [value])
}
